import Vue from 'vue';
import VueRouter from 'vue-router';

import 'ant-design-vue/dist/antd.css';
import {Modal, Form, Input} from 'ant-design-vue';

Vue.component(Modal.name, Modal);
Vue.component(Form.name, Form);
Vue.component(Input.name, Input);

Vue.config.productionTip = false;

import App from './App.vue';

import Login from './components/Login.vue';
import Home from './components/Home.vue';
import OpenDoor from './components/OpenDoor.vue';
import TestScan from './components/TestScan.vue';
import TestOK from './components/TestOk.vue';
import TestFailed from './components/TestFailed.vue';
import BindScanDevice from './components/BindScanDevice.vue';
import BindScanCupboard from './components/BindScanCupboard.vue';
import MarkCupboard from './components/MarkCupboard.vue';
import BindFailed from './components/BindFailed.vue';
import OpenDoorFailed from './components/OpenDoorFailed.vue';
import CheckBoxFailed from './components/CheckBoxFailed.vue';
import BindOk from './components/BindOk.vue';

Vue.use(VueRouter);

let router = new VueRouter({
    routes: [
        {
            path: '/',
            component: Login,
            meta: {
                title: '金盒子自动化测试系统'
            }
        },
        {
            path: '/home',
            component: Home,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/opendoor',
            component: OpenDoor,
            meta: {
                title: '扫码开门'
            }
        },
        {
            path: '/testscan',
            component: TestScan,
            meta: {
                title: '扫码检测'
            }
        },
        {
            path: '/testok',
            component: TestOK,
            meta: {
                title: '自检成功'
            }
        },
        {
            path: '/testfailed',
            component: TestFailed,
            meta: {
                title: '自检失败'
            }
        },
        {
            path: '/bindscandevice',
            component: BindScanDevice,
            meta: {
                title: '扫码主控二维码'
            }
        },
        {
            path: '/bindscancupboard',
            component: BindScanCupboard,
            meta: {
                title: '扫码货柜二维码'
            }
        },
        {
            path: '/markCupboard',
            component: MarkCupboard,
            meta: {
                title: '标记货柜'
            }
        },
        {
            path: '/bindfailed',
            component: BindFailed,
            meta: {
                title: '激活失败'
            }
        },
        {
            path: '/openDoorFailed',
            component: OpenDoorFailed,
            meta: {
                title: '开门失败'
            }
        },
        {
            path: '/checkBoxFailed',
            component: CheckBoxFailed,
            meta: {
                title: '设备异常'
            }
        },
        {
            path: '/bindok',
            component: BindOk,
            meta: {
                title: '激活成功'
            }
        },
    ]
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    next();
})

new Vue({
    el: '#app',
    router: router,
    render: c => c(App),
});
